export enum VotesType {
    agree = "agree",
    disagree = "disagree",
    abstain = "abstain",
    ignored = "ignored",
}
